<template lang="html">
  <button
    class="btn"
    :class="{
      'btn-disabled': disabled,
      'btn-block': block,
      'btn-primary': primary,
      'btn-loading': loading,
      'btn-md': md
    }"
    :type="type"
    @click="emit('click')"
  >
    <clip-loader v-if="loading" loading class="loader" size="14px" />
    <slot />
  </button>
</template>

<script lang="ts" setup>
import ClipLoader from "vue-spinner/src/ClipLoader.vue"

interface ButtonProps {
  block?: boolean
  disabled?: boolean
  primary?: boolean
  loading?: boolean
  md?: boolean
  type?: "button" | "submit" | "reset"
}

withDefaults(defineProps<ButtonProps>(), {
  block: false,
  disabled: false,
  primary: false,
  loading: false,
  md: false,
  type: "button"
})

const emit = defineEmits(["click"])
</script>
